import {Conversation} from '@stripe-internal/conversations-client';

import {LiveChatTopBar} from './LiveChatTopBar';
import {RACTopBar} from './RACTopBar/RACTopBar';
import {useConversationMessageSounds} from '../hooks/useConversationMessageSounds';
import {
  useCurrentConversation,
  useVisibility,
} from '../../../core/hooks/appHooks';
import {useLiveChannelStatus} from '../hooks/useLiveChannelStatus';
import {useUnseenConversationMessages} from '../hooks/useUnseenConversationMessages';

function ConversationTopBar({conversation}: {conversation: Conversation}) {
  const {visibility} = useVisibility();
  const {isLiveChatActive, isRACActive} = useLiveChannelStatus(conversation);

  useUnseenConversationMessages(conversation);
  useConversationMessageSounds(conversation);

  if (visibility !== 'open') {
    return null;
  }

  if (isLiveChatActive) {
    return <LiveChatTopBar conversation={conversation} />;
  } else if (isRACActive) {
    return <RACTopBar conversation={conversation} />;
  } else {
    return null;
  }
}

export function ActiveTopBar() {
  const currentConversation = useCurrentConversation();

  if (!currentConversation) {
    return null;
  }

  return <ConversationTopBar conversation={currentConversation} />;
}
